import { useCallback, useEffect, useRef } from 'react'
import type { Toast } from './useToasts'

/** Stable toast callback — prevents effect loops when parents pass inline lambdas. */
export function useStableToast(push: (message: string, kind?: Toast['kind']) => void) {
  const ref = useRef(push)
  useEffect(() => {
    ref.current = push
  }, [push])

  return useCallback((msg: string, kind?: 'ok' | 'err' | '') => {
    ref.current(msg, kind || '')
  }, [])
}
